export const PAYMENT_REGION_IDS = {
  INDIA: 1,
  GCC: 2,
  US: 3,
};

const trimBaseUrl = (url) => (url ? String(url).replace(/\/$/, "") : "");

const indiaBaseUrl = trimBaseUrl(
  process.env.REACT_APP_ONE_OMS_URL ||
    process.env.REACT_APP_ORDER_API_URL?.replace(
      /\/get-order-payment-overview\/?$/,
      "",
    ),
);

const OMS_BASE_URL_BY_REGION_ID = {
  [PAYMENT_REGION_IDS.INDIA]: indiaBaseUrl,
  [PAYMENT_REGION_IDS.GCC]:
    trimBaseUrl(process.env.REACT_APP_ONE_OMS_GCC_URL) || indiaBaseUrl,
  [PAYMENT_REGION_IDS.US]: trimBaseUrl(process.env.REACT_APP_ONE_OMS_US_URL),
};

export const resolveRegionId = (regionId) => {
  const parsed = Number(regionId);
  if (parsed === PAYMENT_REGION_IDS.GCC || parsed === PAYMENT_REGION_IDS.US) {
    return parsed;
  }
  return PAYMENT_REGION_IDS.INDIA;
};

export const getOmsBaseUrl = (regionId) => {
  const resolvedRegionId = resolveRegionId(regionId);
  return (
    OMS_BASE_URL_BY_REGION_ID[resolvedRegionId] ||
    OMS_BASE_URL_BY_REGION_ID[PAYMENT_REGION_IDS.INDIA]
  );
};

export const getOrderPaymentOverviewUrl = (regionId, orderId) =>
  `${getOmsBaseUrl(regionId)}/get-order-payment-overview/${orderId}`;

export const getPunchPaymentUrl = (regionId) =>
  `${getOmsBaseUrl(regionId)}/punch-payment-v2`;

export const getRazorpayCallbackUrl = (regionId) =>
  `${getOmsBaseUrl(regionId)}/request-callback/RAZORPAY`;

export const getPayuCallbackUrl = (regionId) =>
  `${getOmsBaseUrl(regionId)}/request-callback-v2/PAYU`;
